"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DisabledButton = _interopRequireDefault(require("./DisabledButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LightButton = (0, _styledComponents["default"])(_DisabledButton["default"]).attrs(function () {
  return {
    className: "btn",
    name: "light-button"
  };
}).withConfig({
  displayName: "LightButton",
  componentId: "sc-1q8ivmt-0"
})(["&&&{color:#666666;border-radius:4px;background-color:", ";border:solid 1px ", ";&:hover{", ";", ";}}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.disabled ? "" : "background-color: " + props.theme["grey-three"] + ";";
}, function (props) {
  return props.disabled ? "" : "border: solid 1px " + props.theme["grey-two"] + ";";
});
var _default = LightButton;
exports["default"] = _default;